import { DeleteRequest } from '../../service/model/common/request/delete-request';
import { JourneySearchCriteria } from './flight-rule-search-criteria';
import { Journey } from './journey';

export const FLIGHT_RULE_DELETE_REQUEST_VERSION = '1.0';

export interface FlightRuleCreateRequest {
  version: string;
  journey: Journey;
}

export interface FlightRuleSearchRequest {
  version: string;
  searchJourney: JourneySearchCriteria;
  searchFollowUpRequest?: {
    requestedPageNumber: string;
    numberOfRecords: string;
  };
}

export interface FlightRuleDeleteRequest extends DeleteRequest {
  journey: {
    rule: {
      version: number | string;
      id?: string;
      name?: string;
    };
  };
}

export interface FlightRuleUpdateRequest {
  version: string;
  journey: Journey;
}
